import { JSX } from 'react'
import { Renderers } from '../types'
import { renderers as defaultRenderers } from './renderers'
import { GenericBlock, BlockObjects, type CommonBlockProps } from '../types'

type BlockProps<T extends GenericBlock['type']> = {
  block: BlockObjects[T]
  renderers?: Partial<Renderers>
}

export const Block = <T extends GenericBlock['type']>({ block, renderers, ...props }: BlockProps<T>): JSX.Element => {
  type Renderer = Renderers[T]
  type RendererProps = BlockObjects[T]
  type ReactProps = JSX.IntrinsicAttributes & JSX.LibraryManagedAttributes<Renderer, RendererProps> & CommonBlockProps

  const BlockRenderer: Renderer = renderers?.[block.type] ?? defaultRenderers[block.type]
  const rendererProps = { ...props, ...block } as unknown as ReactProps

  return <BlockRenderer {...rendererProps} />
}
